import { render, staticRenderFns } from "./FormFrecuencia.vue?vue&type=template&id=baf73fa2"
import script from "./FormFrecuencia.vue?vue&type=script&lang=js"
export * from "./FormFrecuencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports